import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
}

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig)
}

const auth = firebase.auth()
const db = firebase.firestore()

const getAllEvents = async () => {
  const currentUser = auth?.currentUser?.uid
  const querySnapshot = await db.collection('events').get()
  const allEvents = querySnapshot.docs.map(doc => doc.data())
  const eventsCreatedByCurrentUser = allEvents.filter(event => event.author === currentUser)
  return eventsCreatedByCurrentUser
}

const addEvent = (id, data) => db.collection('events').doc(id).set(data)
const getEvent = id => db.collection('events').doc(id).get().then(doc => doc.data())
const updateEvent = (id, data) => db.collection('events').doc(id).update(data).then(console.log('document updated successfully'))
const deleteEvent = id => db.collection('events').doc(id).delete().then(console.log('document deleted successfully'))

// const startEventSnapshot = async id => {
//   db.collection('events').doc(id)
//     .onSnapshot((doc) => {
//       const source = doc.metadata.hasPendingWrites ? 'Local' : 'Server'
//       console.log(source, ' data: ', doc.data())
//     }, err => {
//       console.log(err)
//     })
// }

const updateSnapshot = async (id, data) => {
  const event = db.collection('events').doc(id)
  await event.update({
    snapshot: data
  })
}

// TODO: change saving favorites
const addFavoriteActivities = async favs => {
  try {
    const currentUser = auth.currentUser.uid
    let userCollection = await db.collection('users').doc(currentUser).get()
      .then(doc => doc.data())
    if (!userCollection) {
      await db.collection('users').doc(currentUser).set({ favorites: favs, role: '', paid: false })
    } else {
      userCollection = db.collection('users').doc(currentUser)
      await userCollection.update({
        favorites: favs
      })
    }
  } catch (err) {
    console.warn('Sorry, we couldn\'t save it to database', err)
  }
}

// saving stripe payment to firebase
const addStripePayment = async pay => {
  try {
    const currentUser = auth.currentUser.uid
    let userCollection = await db.collection('users').doc(currentUser).get()
      .then(doc => doc.data())
    if (!userCollection) {
      await db.collection('users').doc(currentUser).set({ favorites: [], role: '', paid: pay })
    } else {
      userCollection = db.collection('users').doc(currentUser)
      await userCollection.update({
        paid: pay
      })
    }
  } catch (err) {
    console.warn('Sorry, we couldn\'t save payment to database', err)
  }
}

const getUsersCollection = async () => {
  try {
    const currentUser = auth.currentUser?.uid
    let usersCollection = await db.collection('users').doc(currentUser).get().then(doc => doc.data())
    if (Object.keys(usersCollection).length === 0) {
      usersCollection = { favorites: [], role: '', paid: false } // initializing doc if it was removed from db console
    }
    return usersCollection
  } catch (err) {
    console.warn(err)
    return { favorites: [], role: '', paid: false }
  }
}

const isActivityFavorite = async activityId => {
  try {
    const usersCollection = await getUsersCollection()
    const isFavorite = usersCollection.favorites.find(item => item === activityId)
    return isFavorite
  } catch (err) {
    console.error('Current user\'s doc has empty fields \n', err)
    return false
  }
}

// TODO: change saving favorites

const getCurrentUserRole = async () => {
  try {
    const currentUser = auth.currentUser.uid
    const userCollection = await db.collection('users').doc(currentUser).get()
      .then(doc => doc.data())
    return userCollection.role
  } catch (err) {
    console.warn(err)
    return false
  }
}

const checkForAdmin = async userId => {
  try {
    const userCollection = await db.collection('users').doc(userId).get()
      .then(doc => doc.data())
    return userCollection.role
  } catch (err) {
    console.warn(err)
    return false
  }
}

// let comments = await db.collection('ActivityComments').doc(activityId).get().then(doc => doc.data())
export {
  db,
  auth,
  getAllEvents,
  addEvent,
  getEvent,
  updateEvent,
  deleteEvent,
  addFavoriteActivities,
  getUsersCollection,
  isActivityFavorite,
  getCurrentUserRole,
  checkForAdmin,
  // startEventSnapshot,
  updateSnapshot,
  addStripePayment
}
